import { useEffect, useId, useRef } from 'react';
import styles from './ResetConfirmModal.module.css';

export function ResetConfirmModal({
  open,
  onConfirm,
  onCancel,
  title = '새 대화를 시작할까요?',
  body = '이전 대화 내용은 화면에서 사라집니다. (변호사가 검토할 수 있도록 기록은 보관됩니다.)',
  confirmLabel = '새 대화 시작',
}) {
  const titleId = useId();
  const confirmRef = useRef(null);

  // 부모가 인라인 핸들러를 넘겨도 effect 가 매 렌더 재실행되지 않도록 ref 로 capture
  const onCancelRef = useRef(onCancel);
  useEffect(() => {
    onCancelRef.current = onCancel;
  });

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onCancelRef.current();
    };
    window.addEventListener('keydown', onKey);
    // 모달 열리면 확인 버튼에 포커스 (open 토글 시점에만)
    confirmRef.current?.focus();
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  if (!open) return null;

  return (
    <div
      className={styles.overlay}
      onClick={(e) => {
        if (e.target === e.currentTarget) onCancel();
      }}
    >
      <div className={styles.card} role="dialog" aria-modal="true" aria-labelledby={titleId}>
        <h2 id={titleId} className={styles.title}>
          {title}
        </h2>
        <p className={styles.body}>{body}</p>
        <div className={styles.actions}>
          <button type="button" className={`${styles.btn} ${styles.cancel}`} onClick={onCancel}>
            취소
          </button>
          <button
            type="button"
            ref={confirmRef}
            className={`${styles.btn} ${styles.confirm}`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
